export default "__VITE_ASSET__C5O6gfic__"